<template>
  <node-view-wrapper class="vue-component inline-block">
    <span
      class="bg-yellow-500/20 dark:bg-yellow-800/40 px-2 py-1 rounded cursor-pointer flex items-center space-x-2"
      @click="showPersonalizationDialogue()"
      data-drag-handle>
      <div>{{ previewPhrase }}</div>
      <SegmentIcon class="w-5 opacity-50" />
    </span>

    <Phrase
      :visible="personalizeDialogVisible"
      @update:visible="personalizeDialogVisible = $event"
      :fallbackText="previewPhrase"
      :phraseId="phraseId"
      @save="save()" />
  </node-view-wrapper>
</template>

<script setup>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { UserCircleIcon as SegmentIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  updateAttributes: {
    type: Function,
    required: true
  }
})

const personalizeDialogVisible = ref(false)

const phraseId = computed(() => {
  return props.node.attrs.phraseId
})

const phraseStore = usePhraseStore()
const { phrases } = storeToRefs(phraseStore)

const previewPhrase = computed(() => {
  const phrase = phrases.value.find((p) => p.id === props.node.attrs.phraseId)
  if (phrase) {
    return phrase.fallbackText
  }
})

const showPersonalizationDialogue = () => {
  personalizeDialogVisible.value = true
}

const save = () => {
  personalizeDialogVisible.value = false
}
</script>
